// Plugin to install auth globally in vue
import { Backend } from "./main.js";

export const BackendPlugin = {
  install(Vue, options) {
    Vue.Backend = new Backend(options.config);
  }
};
